import { Injectable } from '@angular/core';
import { WorkflowWidgetCustomConfig } from '../widget-context.type';
import { WidgetContextDataShared } from './widget-context-data.shared';
@Injectable({
  providedIn: 'root'
})
export class WorkflowWidgetConfigService {
  public get flowId(): string {
    const config = WidgetContextDataShared.widgetContext.config;
    return config?.flowId;
  }
  public get customConfig(): WorkflowWidgetCustomConfig {
    const config = WidgetContextDataShared.widgetContext.config;
    return config?.customConfig;
  }
}
